import { render, staticRenderFns } from "./DefaultLayout_mobile.vue?vue&type=template&id=0bb57933&scoped=true"
import script from "./DefaultLayout_mobile.vue?vue&type=script&lang=js"
export * from "./DefaultLayout_mobile.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout_mobile.vue?vue&type=style&index=0&id=0bb57933&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb57933",
  null
  
)

export default component.exports